<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                  <el-row>

                    <el-col :span="12" class="item">
                      <el-form-item label="商家" required prop="businessCode">
                        <el-select v-model="addForm.businessCode" placeholder="请选择商家" style="width: 100%">
                          <el-option
                              v-for="item in arr_business"
                              :key="item.businessCode"
                              :label="item.name"
                              :value="item.businessCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" class="item">
                      <el-form-item label="姓名" required prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入服务人员姓名"></el-input>
                      </el-form-item>
                    </el-col>

                       <el-col :span="12" class="item">
                          <el-form-item label="手机号(登录账号)" required prop="phone">
                              <el-input v-model="addForm.phone"  maxlength="11" placeholder="请输入手机号"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="登录密码" required  prop="password">
                              <el-input v-model="addForm.password" minlength="6" type="password" placeholder="请输入登录密码" show-password></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="12" class="item">
                          <el-form-item label="身份证号" required prop="idCard">
                              <el-input v-model="addForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                          </el-form-item>
                      </el-col>

                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    //import idcardRules from "@/common/idcardRules";
  // const validatorIdNumber = (rule, value, callback) => {
  //   if(value){
  //     if (idcardRules(value)) {
  //         callback();
  //     } else {
  //         return callback(new Error('请输入正确的证件号'))
  //     }
  //   }else{
  //     callback()
  //   }
  //
  // };

    export default {
        name: 'Add',
      props:['arr_business'],
        data() {
            return {
                loading: false,

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                  businessCode:'',
                    name:'',
                    phone:'',
                    password:'',
                    idCard:'',
                },

                rules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入商家名称', trigger: 'blur' },
                    ],
                    password:[
                        { required: true, message: '请输入注册密码', trigger: 'blur' },
                    ],
                    idCard:[
                      { required: true, message: '请输入身份证号', trigger: 'blur' },
                        //{ required: true,validator: validatorIdNumber, trigger: 'blur' }
                    ],
                  businessCode:[
                    { required: true, message: '请选择商家', trigger: 'blur' },
                  ],

                },
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();

            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Serve/AddByGov",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },


        }
    }


</script>
<style lang="scss" scoped>

</style>
